import { createSlice } from "@reduxjs/toolkit";

const rattingCommentSlice = createSlice({
  name: "rattingComment",
  initialState: {
    loading: false,
    pointData: [],
    point: 0,
    error: false,
    rattingData: [],
    totalPage: 0,
    dataAccount: []
  },
  reducers: {
    getRattingPoint: (state) => {
      state.loading = true;
      state.error = false;
    },
    getRattingPointSuccess: (state, action) => {
      state.loading = false;
      state.pointData = action.payload.data
      state.point = action.payload.point
      state.error = false;
    },
    getRattingPointFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    create: (state) => {
      state.loading = true;
      state.error = false;
    },
    createSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    createFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    getRattingData: (state) => {
      state.loading = true;
      state.error = false;
    },
    getRattingDataSuccess: (state, action) => {
      state.loading = false;
      state.rattingData = action.payload.data
      state.totalPage = action.payload.totalPage
      state.dataAccount = action.payload.dataAccount
      state.error = false;
    },
    getRattingDataFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    removeRatting: (state) => {
      state.loading = true;
      state.error = false;
    },
    removeRattingSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    removeRattingFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateRatting: (state) => {
      state.loading = true;
      state.error = false;
    },
    updateRattingSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    updateRattingFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    blockRatting: (state) => {
      state.loading = true;
      state.error = false;
    },
    blockRattingSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    blockRattingFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const rattingCommentActions = rattingCommentSlice.actions;
export default rattingCommentSlice.reducer;
